import { UserIcon } from '@phosphor-icons/react';
import { Badge, Loader, Tabs } from '@mantine/core';
import { useSalesOrderControllerGetSalesOrderWorkOrders } from '@/generated/api/sales-order.ts';
import { useMemo } from 'react';

export default function SalesOrderWorkOrdersTab({
  salesOrderId,
}: {
  salesOrderId: string;
}) {
  const workOrdersQuery =
    useSalesOrderControllerGetSalesOrderWorkOrders(salesOrderId);

  const workOrderCount = useMemo(
    () => (workOrdersQuery.data?.workOrders ?? []).length,
    [workOrdersQuery.data],
  );

  return (
    <Tabs.Tab
      value="work-orders"
      title="Work Orders"
      aria-label="Work Orders"
      leftSection={<UserIcon size={14} />}
      rightSection={
        workOrdersQuery.isLoading ? (
          <Loader size="xs" />
        ) : (
          <Badge size="xs" color={workOrderCount ? 'blue' : 'gray'}>
            {workOrderCount}
          </Badge>
        )
      }
    >
      Work Orders
    </Tabs.Tab>
  );
}
